require('jqmask');

jQuery.validator.addMethod(
    'mobileValidation',
    (value, element) => {
      if ($(element).hasClass('required') === false) {
        return true;
      }

      if (value === undefined || value === null || value === '') {
        return false;
      }

      return (/^1[0-9]{10}$/).test(value);
    }
);

$(() => {
  $("[data-id='mobile']").mask('19999999999', { placeholder: '' });
});

$(document).on('initialized.ocms.ultimate-form', (event, form) => {
  if (OCMS.GlobalVars.Brand === 'occ' && form !== undefined && form !== null && form.id === 'shipping') {
    const UnitedStateSpecificConfigureShippingMethod = () => {
      if (OCMSBagStep3.ChangeOcmsUltimateFormDisabled) {
        return false;
      }

      let poBox = false;
      const state = form.state();

      const poBoxPattern = /^p+(ostal|ost|\.| )*o*(ffice|\.| )*(box)*/i;
      poBox = poBoxPattern.test(form.address()) || poBox;
      poBox = poBoxPattern.test(form.address2()) || poBox;
      poBox = poBoxPattern.test(form.address3()) || poBox;
      poBox = poBoxPattern.test(form.address4()) || poBox;
      poBox = poBoxPattern.test(form.address5()) || poBox;
      poBox = poBoxPattern.test(form.address6()) || poBox;
      poBox = poBoxPattern.test(form.address7()) || poBox;
      poBox = poBoxPattern.test(form.address8()) || poBox;
      poBox = poBoxPattern.test(form.address9()) || poBox;
      poBox = (state === 'AA' || state === 'AE' || state === 'AR') || poBox;

      const list = $("[data-id='shippingMethodList']");
      list.find('.rdblistShippingMethodStep3 input:radio').attr('disabled', poBox === true);
      list.find(".rdblistShippingMethodStep3[data-title='Standard PO Box / APO / FPO'] input:radio").attr('disabled', poBox === false);
      list.find(".rdblistShippingMethodStep3[data-title='Standard PO Box / APO / FPO'] input:radio").attr('checked', poBox === true);

      if (state === 'AK' || state === 'HI' || state === 'PR') {
        const hazmat = $("input[type='hidden'][id$='hazmatFilterOn']").val() === 'true';
        list.find('.rdblistShippingMethodStep3 input:radio').attr('disabled', true);
        list.find('.rdblistShippingMethodStep3 input:radio').attr('checked', false);
        if (!poBox) {
          list.find(".rdblistShippingMethodStep3[data-title='Standard to Alaska, Hawaii and Puerto Rico'] input:radio").attr('disabled', hazmat === true);
          list.find(".rdblistShippingMethodStep3[data-title='Standard to Alaska, Hawaii and Puerto Rico'] input:radio").attr('checked', hazmat === false);
          list.find(".rdblistShippingMethodStep3[data-title='Express to Alaska, Hawaii and Puerto Rico'] input:radio").attr('disabled', hazmat === false);
          list.find(".rdblistShippingMethodStep3[data-title='Express to Alaska, Hawaii and Puerto Rico'] input:radio").attr('checked', hazmat === true);
        }
      } else {
        list.find(".rdblistShippingMethodStep3[data-title='Standard to Alaska, Hawaii and Puerto Rico'] input:radio").attr('disabled', true);
        list.find(".rdblistShippingMethodStep3[data-title='Standard to Alaska, Hawaii and Puerto Rico'] input:radio").attr('checked', false);
        list.find(".rdblistShippingMethodStep3[data-title='Express to Alaska, Hawaii and Puerto Rico'] input:radio").attr('disabled', true);
        list.find(".rdblistShippingMethodStep3[data-title='Express to Alaska, Hawaii and Puerto Rico'] input:radio").attr('checked', false);
      }
      // list.find(".rdblistShippingMethodStep3 input:radio").trigger("change");
      OCMSBagStep3.refreshShippingMethodSelection();
      return list;
    };
    UnitedStateSpecificConfigureShippingMethod();
    $(document).on('change.ocms.ultimate-form', UnitedStateSpecificConfigureShippingMethod);
  }
});



// WEBPACK FOOTER //
// ./js/countryForm/united-states.form.js